<form class="flex grid-cols-3 flex-wrap gap-4" [formGroup]="dateRange">
  @if (predefinedDateActions()) {
    <mat-form-field subscriptSizing="dynamic" [appearance]="appearance">
      <mat-label>Select a predefined date</mat-label>
      <mat-select
        placeholder="Predefined Dates"
        formControlName="predefinedDate"
        (selectionChange)="updatePredefinedDate($event)"
      >
        <mat-option
          *ngFor="let predefinedDate of predefinedDates; trackBy: trackByDate"
          [value]="predefinedDate"
        >
          {{ predefinedDate.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  }
  @if (!useRangePicker) {
    <mat-form-field
      class="w-56"
      subscriptSizing="dynamic"
      [appearance]="appearance"
    >
      <mat-label>{{ startDateLabel }}</mat-label>
      <input
        matInput
        formControlName="from"
        [matDatepicker]="fromInput"
        [max]="dateRange.value.to"
        (focus)="fromInput.open()"
        (click)="fromInput.open()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="fromInput" />
      <mat-datepicker #fromInput />
    </mat-form-field>
    <mat-form-field
      class="w-56"
      subscriptSizing="dynamic"
      [appearance]="appearance"
    >
      <mat-label>{{ endDateLabel }}</mat-label>
      <input
        matInput
        formControlName="to"
        [matDatepicker]="toInput"
        [min]="dateRange.value.from"
        (focus)="toInput.open()"
        (click)="toInput.open()"
      />
      <mat-datepicker-toggle matIconSuffix [for]="toInput" />
      <mat-datepicker #toInput />

      @if (dateRange.controls.from.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date</mat-error>
      }

      @if (dateRange.controls.to.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date</mat-error>
      }
    </mat-form-field>
  } @else {
    <mat-form-field subscriptSizing="dynamic" [appearance]="appearance">
      <mat-label>{{ dateLabel() }}</mat-label>
      <mat-date-range-input [rangePicker]="rangePicker">
        <input matStartDate placeholder="Start date" formControlName="from" />
        <input matEndDate placeholder="End date" formControlName="to" />
      </mat-date-range-input>

      <mat-datepicker-toggle matIconSuffix [for]="rangePicker" />

      <mat-date-range-picker #rangePicker />
    </mat-form-field>
  }
</form>
